export function fetchDataForFluentOverview({
  serverContext,
  preferenceService,
  resolve,
  reject,
  queryParam,
}) {
  if (
    serverContext.WelcomeStatus &&
    serverContext.WelcomeStatus.ShowWelcomeTips
  ) {
    import(/* webpackMode: 'eager' */ '@bingads-webui-campaign-legacy/dashboard-page/dashboard/data-fetch-welcome')
      .then(({ fetchWelcomeTipData }) => {
        fetchWelcomeTipData();
        resolve();
      });
  } else {
    Promise.all([
      import(/* webpackMode: 'eager' */ '@bingads-webui-campaign/filter-storage'),
      import(/* webpackMode: 'eager' */ '@bingads-webui-campaign-react/shell-ui-common'),
      import(/* webpackMode: 'eager' */ '@bingads-webui-campaign/overview-panel'),
      import(/* webpackMode: 'eager' */ '@bingads-webui-campaign/fluent-page-data'),
      import(/* webpackMode: 'eager' */ '@bingads-webui-component-legacy/preference/service/index'),
      import(/* webpackMode: 'eager' */ '@bingads-webui-component-legacy/config/index'),
      import(/* webpackMode: 'eager' */ '@bingads-webui-campaign-legacy/instrumentation/index'),
      import(/* webpackMode: 'eager' */ '@bingads-webui-component-legacy/js-data-campaign/index'),
    ])
      .then(([
        { WaterfallFilterStorage, WaterfallFilterType },
        { getFilteredCampaignTypeFromWaterfallFilter },
        { DateFilterState },
        { fetchFluentOverviewTilesData },
        { default: preference },
        { default: legacyConfig },
        { default: featureInstrumentation },
        { default: jsdata },
      ]) => {
        const waterfallFilterStorage = new WaterfallFilterStorage({
          preferenceService,
        });

        const filter = waterfallFilterStorage.getFilters([
          WaterfallFilterType.CampaignType,
          WaterfallFilterType.CampaignStatus,
          WaterfallFilterType.AdGroupStatus,
        ]);

        const campaignType = getFilteredCampaignTypeFromWaterfallFilter(filter);

        preference
          .initialize()
          .then(() => {
            const permissions = {
              ...serverContext.Permissions,
              dynamic: serverContext.DynamicPermissions,
            };

            fetchFluentOverviewTilesData({
              serverContext,
              filter,
              campaignType,
              resolve,
              reject,
              DateFilterState,
              preference,
              queryParam,
              jsdata,
              permissions,
              legacyConfig,
              featureInstrumentation,
            });
          })
          .catch((error) => {
            console.error('Error initializing preference service:', error);
            reject(error);
          });
      })
      .catch((error) => {
        console.error('Error loading modules:', error);
        reject(error);
      });
  }
}
